// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Star Wars Universe - Main Export
 */

import { starSystems, starPositions } from './StarSystemsConfig';
import { warpGates, warpGatePositions } from './WarpGatesConfig';
import { StarWarsAliensPlanets } from './AliensConfig';

export const universeStarWars = {
  id: 'starwars',
  starSystems,
  starPositions,
  warpGates,
  warpGatePositions,
  aliens: StarWarsAliensPlanets
};

export default universeStarWars;
